'use client'

import { GlobalError as GlobalErrorUI } from '@pattern-library/complexUI/GlobalError'
import Error from 'next/error'

import { EnglishIntlProvider } from './_components/EnglishIntlProvider'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  console.error('Global error:', error)
  return (
    <html>
      <body>
        {/* global-error replaces the root layout, so it must provide its own intl context */}
        <EnglishIntlProvider>
          <GlobalErrorUI />
        </EnglishIntlProvider>
      </body>
    </html>
  )
}
